import React, {useEffect} from 'react'
import {
    CAT_MENU_DEFAULT_ROOT_CATEGORY,
    CAT_MENU_NAV_LINK_LABEL,
    SITEMAP_CAVENDERS_LABEL
} from '../../../constants'
import {useCategory} from '@salesforce/commerce-sdk-react'
//import Link from '@salesforce/retail-react-app/app/components/link'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {SiteMapStyle} from './styles'
import PropTypes from 'prop-types'

const SiteMap = ({setBreadcrumbData}) => {
    const {data: navigationCatgoriesLink} = useCategory({
        parameters: {id: CAT_MENU_DEFAULT_ROOT_CATEGORY, levels: CAT_MENU_NAV_LINK_LABEL}
    })

    useEffect(() => {
        setBreadcrumbData({
            parentFolder: {
                folderId: 'customer-service',
                folderName: 'Customer Service',
                url: '/customer-service'
            },
            contentFolder: {
                folderId: 'site-map',
                folderName: 'SITE MAP',
                url: '/sitemap'
            }
        })
    }, [])

    return (
        <Box sx={SiteMapStyle}>
            <h1>{SITEMAP_CAVENDERS_LABEL}</h1>
            <div className="category-list">
                {navigationCatgoriesLink?.categories.map((category, index) => (
                    <div className="category-item" key={index}>
                        <h2>
                            <a href={`/${category.id}`}>{category.name}</a>
                        </h2>
                        {category.categories?.length && (
                            <ul>
                                {category.categories.map((subCategory, subIndex) => (
                                    <li key={subIndex}>
                                        <a href={`/${subCategory.id}`}>{subCategory.name}</a>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </Box>
    )
}

SiteMap.propTypes = {
    setBreadcrumbData: PropTypes.func.isRequired
}

export default SiteMap
